import { Location } from '@cobliteam/common-types';
import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import { Redirect, Route, Switch } from 'react-router-dom';

const CoachingPage = ({ routes }: any) => {
  const { runtimeFlags } = useDashboard();

  return (
    <Switch>
      {!runtimeFlags.hasCameraFlag && <Redirect path='*' to={Location.NOT_FOUND} />}
      {routes.map((route: any) => {
        return <Route key={route.path} path={route.path} exact={route.exact} render={(props) => <route.component {...props} routes={route.routes} />} />;
      })}
    </Switch>
  );
};

export default CoachingPage;
